import React, { useRef } from 'react';

import SideBar from '../Sidebar';
import Tables from './Tables';

import { Node } from '../../types';
import scrollTo from '../../util/scrollTo';

import '../../styles/Processes.css';

type Props = {
  nodes: Node[];
}

const generateContents = (nodes: Node[]) => nodes.map((node, index) => {
  return (
      <li className='be_chapter-item' key={`be_chapter-item-${index}`}>
        <a onClick={() => scrollTo('.be_doc', `${node.name}-${index}`)}>{node.name}</a>
      </li>
  );
}).flat();

const Processes = ({ nodes }: Props) => {

  const contentWorkflow = nodes.filter((node) => node.group === 'workflow');
  const contentDataset = nodes.filter((node) => node.group === 'dataset');

  const tocWorkflow = generateContents(contentWorkflow);
  const tocDataset = generateContents(contentDataset);
  
  const printRef = useRef<HTMLInputElement>(null);

  return (
    <div className='be_Processes'>
      <SideBar contentRef={printRef}>
        <li className='be_chapter-item'>
          <a onClick={() => scrollTo('.be_doc', `be_workflow`)} style={{ fontSize: '1.2em' }}>Workflows</a>
        </li>
        <li className='be_chapter-item'>
          <ol>
            {tocWorkflow}
          </ol>
        </li>
        <li className='be_chapter-item'>
          <a onClick={() => scrollTo('.be_doc', `be_dataset`)} style={{ fontSize: '1.2em' }}>Datasets</a>
        </li>
        <li className='be_chapter-item'>
          <ol>
            {tocDataset}
          </ol>
        </li>
      </SideBar>
      <div className="be_doc" ref={printRef}>
        <Tables nodes={nodes} type={'workflow'} />
        <Tables nodes={nodes} type={'dataset'} />
      </div>
    </div>
  );
};

export default Processes;